import { useNavigate, useOutletContext } from 'react-router';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import styles from './MonthlyReportHome.module.scss';
import { HiCheckCircle, HiArrowNarrowRight as RightIcon } from 'react-icons/hi'
import { LendingStatus, monthlyReportRoutes, PcColdStates, UnderwritingColdState, UnderwritingFormStatus, underwritingRoutes } from '../../../interfaces/interfaces';
import usePageTitle from '../../../components/Hooks/usePageTitle';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MdCheckCircle as CheckCircleIcon } from 'react-icons/md'
import { BsFillExclamationTriangleFill } from 'react-icons/bs'
import { RestS } from '../../../rest/rest-service';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import HeaderTitle from '../../../components/common/HeaderTitle';
import LandingImage from '../../../assets/images/Monthly Report Landing 2x.png';
// import { initialStepperlist } from '../UnderwritingSections/UnderwritingSections';
import { useAppDispatch, useAppSelector } from '../../../redux/reduxHooks';
import { setRefreshUwHome } from '../../../redux/underwriting/underwriting';
import { monthlyReportStepperList } from './monthlyReport.helper';

// import LandingPnlImage from '../../../assets/images/supplierPayments/landing 2x.png';

const helpPoints = ["Answer a few quick questions", "Upload bank statements", "Connect GST"];

const BtnText = {
  [UnderwritingColdState.inProgress]: "In Progress",
}

export const getMonthYearFromStr = (monthYear) => {
  const [month, year] = monthYear.split("-");
  const date = new Date(`${year}-${month}-01`);
  const formatted = date.toLocaleString('default', { month: 'short', year: 'numeric' }); // → "Apr 2025"
  return formatted
}

const MonthlyReportHome = () => {
  const navigate = useNavigate();
  const pageTitle = usePageTitle('Investor Report | Merito');
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [getStartedLoading, setGetStartedLoading] = useState(false);
  const [uwColdState, setUwColdState] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [monthYear, setMonthYear] = useState(null)

  const { setHeaderContent, resetHeaderContent } = useOutletContext<any>();

  const { refreshUwHome } = useAppSelector(state => state.underwriting)
  const dispatch = useAppDispatch();

  useEffect(() => {
    setHeaderContent(
      <HeaderTitle isNav={false} headerTitle={`Monthly Report`} />
    );
    return () => {
      resetHeaderContent();
    };
  }, []);

  const initialStepperListObj = useMemo(() => {
    return monthlyReportStepperList.reduce((prev, curVal) => {
      prev[curVal.name] = curVal;
      return prev;
    }, {})
  }, []);


  useEffect(() => {
    if (searchParams.get("token")) {
      searchParams.delete("token")
      setSearchParams(searchParams)
    }
    // if (update?.updateAvailable) {
    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.style.overflowY = "hidden";
    const pageIndexLayout: any = document.getElementById("page_body");
    if (pageIndexLayout) {
      // pageIndexLayout.style.overflowY = "hidden";
      pageIndexLayout.style.padding = "0rem";
    }

    return () => {
      const bodyElement = document.getElementsByTagName("body")[0];
      const pageIndexLayout: any = document.getElementById("page_body");
      if (pageIndexLayout) {
        pageIndexLayout.style.overflowY = "scroll";
        pageIndexLayout.style.padding = "1rem 1.5rem 2rem 1.5rem";
      }
      pageTitle('')
    };
    // }
  }, []);

  const checkAndSetJourneyStatus = async () => {
    const res = await RestS.checkMonthlyReportJourney();
    console.log('res', res)
    const { coldState, monthlyReportData, allowGetStarted, userDetails } = res


    setMonthYear(getMonthYearFromStr(monthlyReportData?.monthYear))

    if (coldState == UnderwritingColdState.accessDenied) {
      navigate('/404', {
        replace: true
      })
    }
    else if (coldState == UnderwritingColdState.inProgress) {
      setUserDetails(userDetails);
      setUwColdState(coldState);
    } else {
      setUwColdState(coldState);
    }
  }

  useEffect(() => {
    console.log('uwColdState', uwColdState)
  }, [uwColdState])

  useEffect(() => {
    (async () => {
      try {
        await checkAndSetJourneyStatus();
        // }
      } catch (error) {
        console.log('error', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (refreshUwHome) {
      checkAndSetJourneyStatus();
      dispatch(setRefreshUwHome(false))
    }
  }, [refreshUwHome])

  // const initialStepperListObj = useMemo(() => {
  //   return initialStepperlist.reduce((prev, curVal) => {
  //     prev[curVal.name] = curVal;
  //     return prev;
  //   }, {})
  // }, []);

  const handleGetStarted = async () => {
    try {
      // setGetStartedLoading(true);
      // const { coldState, underwritingData, allowGetStarted, userDetails } = await RestS.checkUnderwritingJourney();
      // let submitFormData = null;
      // if (coldState == UnderwritingColdState.inProgress) {
      //   setUserDetails(userDetails);
      //   setUwColdState(coldState);
      // } else {
      //   setUwColdState(coldState);
      // }
      // if (!underwritingData) {
      //   submitFormData = {
      //     data: null,
      //     step: null,
      //     applicationStatus: LendingStatus.IN_PROGRESS
      //   }
      // } else {
      //   // console.log('underwritingFormData', underwritingData)
      //   submitFormData = {
      //     data: underwritingData?.data,
      //     step: null,
      //     applicationStatus: LendingStatus.IN_PROGRESS
      //   }
      // }
      // const { formStatuses, formData }: any = await RestS.submitUnderwritingFormData(submitFormData);
      // let incompleteStep = null;
      // for (const step of formStatuses) {
      //   if (step.status == UnderwritingFormStatus.INCOMPLETE) {
      //     incompleteStep = step;
      //     break;
      //   }
      // }
      // if (incompleteStep) {

      //   let navigateLink = initialStepperListObj[incompleteStep.step].link;
      //   console.log('navigate link', navigateLink)
      //   navigate(navigateLink)
      // }
      const { formStatuses, formData } = await RestS.fetchMonthlyReportFormData();
      // console.log('response', response);
      let incompleteStep = null;
      if (formStatuses.length) {
        for (const step of formStatuses) {
          if (step.status == UnderwritingFormStatus.INCOMPLETE) {
            incompleteStep = step;
            break;
          }
        }
        if (incompleteStep) {
          let navigateLink = initialStepperListObj[incompleteStep.step]?.link;
          console.log('navigate link', navigateLink)
          navigate(navigateLink)
        } else {
          navigate(monthlyReportRoutes.recipients)
        }
      } else {
        navigate(monthlyReportRoutes.connectAccounts);
      }
    } catch (error) {
      console.log('error', error);
      // throw error;
    } finally {
      setGetStartedLoading(false);
    }
  }

  const journeyDataText = useMemo(() => {
    if (uwColdState == UnderwritingColdState.inProgress) {
      const userName = userDetails.name.toString().trim();
      return <>{`${userName} is working on your brand’s Merito Credit Form.`} <br />  {`You can view it once they’ve completed.`}</>
    } else {
      return null;
    }

  }, [uwColdState, userDetails]);



  return (
    <div className={styles.underwritingRootContainer}>
      {loading ?
        <div className={styles.loadingContainer}>
          <CircularLoader />
        </div>
        :
        uwColdState == UnderwritingColdState.completed ?
          <>
            <div className={styles.successScreen}>
              <HiCheckCircle />
              <h2>
                Your <span>{monthYear}</span> Report<br />Has Been Sent to Investors!
              </h2>
              <p>Need to make changes? Contact Merito</p>
            </div>
          </>
          :
          <>
            <div className={styles.leftContainer}>
              <div className={styles.homeRootContainer}>
                <div className={styles.warningContainer}>
                  <BsFillExclamationTriangleFill />
                  {/* Short month name: dynamic as per current month */}
                  <p> Complete this report by {new Date().toLocaleString('en-US', { month: 'short' })} 7</p>
                </div>
                <div className={styles.title}>
                  Send Your Monthly <br />
                  Report <span>in Minutes!</span>
                </div>
                <div className={styles.helpContainer}>
                  <div className={styles.helpTitle}>
                    Takes just 5 minutes!
                  </div>
                  <ul className={styles.listContainer}>
                    {helpPoints.map((item, index) => {
                      return (
                        <li className={styles.listItem}>
                          <CheckCircleIcon />
                          <p className={styles.listItemText}>{item}</p>
                        </li>
                      )
                    })}
                  </ul>
                  <p>Thats it!</p>
                </div>
                <div className={styles.subTitle}>
                  Keep your investors in the loop.
                </div>
              </div>
              <div>
                <MeritoButton size='lg' type='primary-1' disabled={uwColdState == UnderwritingColdState.inProgress} btnText={uwColdState == UnderwritingColdState.inProgress ? BtnText[UnderwritingColdState.inProgress] : "Fill Report"} icon={<RightIcon />} showLoadingWithText={true} loading={uwColdState == UnderwritingColdState.inProgress || getStartedLoading} isIconToRight={true} onClick={handleGetStarted} />
              </div>
              {uwColdState == UnderwritingColdState.inProgress && journeyDataText ?
                <div className={styles.journeyProgressColdState}>
                  {journeyDataText}
                </div> : null}
            </div>
            <div className={styles.rightContainer}>
              <div className={styles.imgContainer}>
                {/* <img className={styles.topShadowImg} src={TopShadowImage} />
              <img className={styles.bottomShadowIamge} src={BottomShadowImage} /> */}
                <img className={styles.landingImg} src={LandingImage} alt="" />

                {/* <img src={LandingPnlImage} alt="" /> */}

              </div>
            </div>
          </>

      }

    </div >
  );
}

export default MonthlyReportHome;